import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { getCssVariableValue, hexToRgb } from 'shared/style-utils.js'

const baseInputStyle = `
    width: 100%;
    border-width: 1px;
    border-style: solid;
    border-radius: 6px;
    padding: 12px;
    height:48px;
    font-size: 16px;
    font-family: Roboto,sans-serif;
    line-height:24px;
    margin-top: 5px;
    margin-bottom: 10px;
    border-color: rgb(204 204 204);
`

const wideInputStyle = `
    ${baseInputStyle}
    width: 100%;
`

const narrowInputStyle = `
    ${baseInputStyle}
    width: 60px;
`

let labelStyle = `
font-family: Roboto,sans-serif;
font-size: 16px;
font-weight:400;
line-height:24px;
text-transform: uppercase;
`

const AddCreditCard = ({
    translate: t,
    setError,
    setToken,
    forwardedIframeRef,
    forwardedInputRef,
    onLoad,
    isLoading,
}) => {
    const intl = useIntl()
    const generalErrorMessage = intl.formatMessage({ id: 'Moneris.Creditcard.Error.General' })
    const primaryColor = hexToRgb(getCssVariableValue('--brand-primary-color'))

    const respMsg = e => {
        if (e.origin === MONERIS_TOKENIZATION_PAGE) {
            const respData = JSON.parse(e.data)

            if (respData.dataKey) {
                setToken(respData.dataKey, respData.bin?.slice(0, 6))
            }

            if (respData.errorMessage) {
                setError(generalErrorMessage || respData.errorMessage)
            }
        }
    }

    useEffect(() => {
        window.addEventListener('message', respMsg, false)
        return () => window.removeEventListener('message', respMsg, false)
    }, [])

    useEffect(() => {
        if (primaryColor) {
            labelStyle += `color: ${primaryColor};`
        }
    }, [primaryColor])

    // https://developer.moneris.com/en/Documentation/NA/E-Commerce%20Solutions/Hosted%20Solutions/Hosted%20Tokenization
    const iframeSrc = `${MONERIS_TOKENIZATION_PAGE}/HPPtoken/index.php?id=${MONERIS_IFRAME_TOKEN}&pmmsg=true&css_body=${labelStyle}&css_textbox_pan=${wideInputStyle}&enable_exp=1&display_labels=1&css_textbox_exp=${narrowInputStyle}&enable_cvd=1&css_textbox_cvd=${narrowInputStyle}&pan_label=${t(
        'moneris.creditcard.card.number.label'
    )}&exp_label=${t('moneris.creditcard.expiry.label')}&cvd_label=${t('moneris.creditcard.cvc.label')}`

    return (
        <div className="d-flex flex-column" style={{ opacity: isLoading ? '0' : '1' }}>
            <label htmlFor="monerisNameOnCardInput" className="label text-left">
                <T>moneris.creditcard.cardholder.name.label</T>
            </label>
            <input ref={forwardedInputRef} className="input" id="monerisNameOnCardInput" />
            <iframe
                className="monerisIfrmame"
                title="credit card form"
                onLoad={onLoad}
                ref={forwardedIframeRef}
                id="monerisFrame"
                src={iframeSrc}
                frameBorder="0"
                width="100%"
                height="265px"
            />
        </div>
    )
}

export default withTranslate(AddCreditCard)
